<template>
  <div class="page-setting">
    <div class="home">
      <edit-box></edit-box>
    </div>
    <el-row class="btn">
      <el-button type="primary" @click="submit">立即保存</el-button>
    </el-row>
  </div>
</template>
<script>
import request from '@/utils/request'
import editBox from '../pages/components/editBox'
export default {
  components: {
    editBox
  },
  data () {
    return {
      page: {
        style: {
          padding: 0
        },
        modules: []
      }
    }
  },
  created () {
    request({
      url: '/ui/movie/sponsor-page?lang=en',
      method: 'get'
    }).then(res => {
      if (res.data.content && res.data.content.modules && res.data.content.modules.length) {
        this.page = res.data.content
      }
      this.$store.commit('SET_PAGE', this.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
    })
  },
  methods: {
    submit () {
      request({
        url: '/ui/movie/sponsor-page',
        method: 'put',
        data: {
          lang: 'en',
          page: this.page
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page-setting {
  .home {
    display: flex;
  }
  .btn {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/sponsorEn.vue